export const language = {
  zh: {
    'Your collection list is empty，hurry up and act！': '您的收藏清单还是空的，赶快行动起来，收藏商品吧！',
    'Home': '商城首页',
    'XX suppliers in total': '共XX个供应商',
    'Select All': '全选',
    'Add to Cart': '加入购物车',
    'Planned Order': '加入计划单',
    'Please Enter A Keyword': '请输入搜索关键字',
    'Search': '搜索',
    'More': '展开',
    'Invalid Commodity List': '失效商品列表',
    'List Off': '下架',
    'There Are': '共',
    'Suppliers': '个供应商',
    'On Lining': '该功能即将上线',

  },
  en: {
    'Your collection list is empty，hurry up and act！': 'Your collection list is empty，hurry up and act！',
    'Home': 'Home',
    'There Are': 'There Are',
    'Suppliers': 'Suppliers',
    'Select All': 'Select All',
    'Add to Cart': 'Add to Cart',
    'Planned Order': 'Planned Order',
    'Please Enter A Keyword': 'Please Enter A Keyword',
    'Search': 'Search',
    'More': 'More',
    'Invalid Commodity List': 'Invalid Commodity List',
    'List Off': 'List Off',
    'On Lining': 'On Lining',

  }
};
